import { formatDateTime } from "../../../users/adminUserFormatters";
import { formatFrameAge } from "../../../../../../utils/radarHealthAdminUtils";
import WeatherHealthBadge from "../WeatherHealthBadge";

const WeatherRadarLatestFrameModal = ({
  isOpen = false,
  framePayload,
  imageUrl,
  loading,
  errorMessage,
  onClose,
}) => {
  if (!isOpen) {
    return null;
  }

  const frame = framePayload?.frame;

  return (
    <div className="admin-re-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="admin-re-modal panel-card weather-radar-frame-modal"
        role="dialog"
        aria-labelledby="weather-radar-frame-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="admin-re-modal-header">
          <div>
            <p className="eyebrow">Official radar preview</p>
            <h2 id="weather-radar-frame-modal-title">
              {framePayload?.sourceLabel || "IDEAM Imagen Compuesta"}
            </h2>
          </div>
          <button type="button" className="midpoint-share-button" onClick={onClose}>
            Close
          </button>
        </header>

        <div className="admin-re-modal-body">
          {loading ? <p className="muted">Loading latest cached frame…</p> : null}
          {errorMessage ? <p className="admin-re-error">{errorMessage}</p> : null}

          {!loading && !errorMessage && frame ? (
            <>
              <div className="weather-radar-frame-modal__meta">
                <WeatherHealthBadge status={frame.renderable ? "healthy" : "unavailable"} />
                <span>Renderable: {frame.renderable ? "Yes" : "No"}</span>
              </div>

              {imageUrl ? (
                <div className="weather-radar-frame-modal__preview">
                  <img src={imageUrl} alt="Latest cached IDEAM BART radar frame" />
                </div>
              ) : null}

              <dl className="weather-radar-frame-modal__details">
                <div>
                  <dt>Timestamp</dt>
                  <dd>{frame.timestampUtc ? formatDateTime(frame.timestampUtc) : "—"}</dd>
                </div>
                <div>
                  <dt>Age</dt>
                  <dd>{formatFrameAge(frame.latestFrameAgeMinutes)}</dd>
                </div>
                <div>
                  <dt>Filename</dt>
                  <dd>{frame.filename || "—"}</dd>
                </div>
                <div>
                  <dt>Size</dt>
                  <dd>{frame.sizeBytes != null ? `${frame.sizeBytes} bytes` : "—"}</dd>
                </div>
              </dl>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default WeatherRadarLatestFrameModal;
